/**
 * TotalKlick SSO helper (Service Provider side).
 *
 * Usage:
 *   loginWithTotalKlick()                  // call from "Accedi con TotalKlick" button
 *   handleTotalKlickCallback(searchParams) // call from /auth/sso/callback page
 */

const TOTALKLICK_BASE_URL =
  process.env.REACT_APP_TOTALKLICK_BASE_URL || "https://totalklick.it";
const APP_KEY = process.env.REACT_APP_TOTALKLICK_APP_KEY || "gostreet";

const STATE_KEY = "tk_sso_state";

function randomState() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

/** Redirect the user to the TotalKlick authorize endpoint. */
export function loginWithTotalKlick(returnPath = "/auth/sso/callback") {
  const state = randomState();
  try {
    sessionStorage.setItem(STATE_KEY, state);
  } catch {
    /* sessionStorage might be blocked — proceed but accept reduced anti-CSRF */
  }
  const returnUrl = `${window.location.origin}${returnPath}`;
  const params = new URLSearchParams({
    app_key: APP_KEY,
    return_url: returnUrl,
    state,
  });
  window.location.href = `${TOTALKLICK_BASE_URL}/api/auth/sso/authorize?${params.toString()}`;
}

/**
 * Read sso=... and state=... from URL, validate state, POST to backend for verify+session.
 * Returns: { token, user } on success.
 */
export async function consumeTotalKlickCallback(searchParams, apiUrl) {
  const ssoToken = searchParams.get("sso");
  const state = searchParams.get("state");
  if (!ssoToken) throw new Error("Token SSO mancante");

  let savedState = null;
  try {
    savedState = sessionStorage.getItem(STATE_KEY);
    sessionStorage.removeItem(STATE_KEY);
  } catch {
    /* ignore */
  }
  if (savedState && state && savedState !== state) {
    throw new Error("Sessione SSO non valida (state mismatch)");
  }

  const res = await fetch(`${apiUrl}/api/auth/sso/totalklick/callback`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ sso_token: ssoToken }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `Verifica SSO fallita (${res.status})`);
  }
  return res.json();
}
